import React from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { SvgIconComponent } from '@mui/icons-material';
import { accentColor, AMBER, DemoAccent } from '../demoContent';

interface IconTileProps {
  Icon: SvgIconComponent;
  accent?: DemoAccent;
  /** Frosted tile with an amber icon, for the navy bands. */
  onDark?: boolean;
  size?: number;
}

/** The single icon treatment used everywhere on the page: a rounded square, tinted, one size. */
export default function IconTile({ Icon, accent = 'navy', onDark = false, size = 48 }: IconTileProps) {
  const theme = useTheme();
  const color = accentColor(accent, theme);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: onDark ? 'rgba(255, 255, 255, 0.1)' : alpha(color, 0.12),
        color: onDark ? AMBER.main : color,
      }}
    >
      <Icon sx={{ fontSize: Math.round(size * 0.54) }} />
    </Box>
  );
}
